<div [ngClass]="{ wrapper: true, 'no-label-excluded': mode === 'annotate' }">
    <div class="header">
        <p>Labels</p>
    </div>
    <div class="label-creation-wrapper">
        <div class="input-field-wrapper">
            <input
                #labelName
                id="label-name"
                type="text"
                [class]="canEdit ? 'input-field' : 'input-field disabled'"
                [formControl]="categoryInput"
                (keyup)="onKeyUpCategoryInput($event)"
                [placeholder]="
                    'imgDb.labelManager.input.placeholder' | translate
                "
                (keydown)="$event.stopPropagation()"
            />
            <div
                class="clear-button"
                id="clear-input-field-button"
                *ngIf="categoryInput.value"
                (click)="onResetFormAndInputFieldFilteredCategories()"
            >
                <span class="material-icons clear-icon">clear</span>
            </div>
        </div>
        <button
            id="add-new-label-button"
            class="add-button"
            (click)="onEnterKeypressAddCategory(categoryInput.value?.trim())"
            [disabled]="showSpinner || !canEdit"
        >
            <p>+</p>
        </button>
    </div>
    <div class="sorting-wrapper">
        <select
            id="category-sorting-dropdown"
            [formControl]="selectedSortingOption"
            (change)="onSortingChange()"
        >
            <option
                class="sorting-option"
                *ngFor="let sortingOption of sortingOptions"
                [value]="sortingOption"
                [id]="sortingOption"
                [title]="
                    'imgDb.labelManager.sorting.' + sortingOption | translate
                "
            >
                {{ sortingOption }}
            </option>
        </select>
        <div class="radio-group">
            <label
                *ngFor="let option of availableOptions"
                [ngClass]="{ selected: selectedOption === option }"
                [id]="'radio-button-' + option"
                [title]="
                    'imgDb.labelManager.sortingRadioButtons.' +
                        option +
                        '.tooltip' | translate
                "
            >
                <input
                    type="radio"
                    name="option"
                    [(ngModel)]="selectedOption"
                    [value]="option"
                    (click)="onCountingGroupChange(option)"
                />
                <span class="custom-radio"></span>
                <p>
                    {{
                        'imgDb.labelManager.sortingRadioButtons.' +
                            option +
                            '.value' | translate
                    }}
                </p>
            </label>
        </div>
    </div>
    <ul
        [ngClass]="{
            'list-group': true,
            'categories-list': true,
            'no-label-excluded-in-list': mode === 'annotate'
        }"
        *ngIf="inputFilteredCategories?.length > 0 && !showSpinner"
        aria-multiselectable="true"
    >
        <li
            *ngFor="let category of inputFilteredCategories; index as idx"
            [class]="{
                'list-group-item': true,
                'category-item': true,
            }"
            [attr.aria-selected]="isCategoryActive(category)"
        >
            <div
                [class]="{
                    'main-category-entry': true,
                    selected: isCategoryActive(category),
                }"
                [style]="{
                    backgroundColor:
                        isCategoryActive(category) ||
                        hoveredCategoryIndex === idx
                            ? getColor(
                                  categoryIndexForRenaming === idx
                                      ? currentRenamingCategoryName
                                      : category.name
                              )
                            : '#ebedf1'
                }"
                [title]="category.name"
                (click)="onClickCategory(category)"
                (mouseenter)="hoveredCategoryIndex = idx"
                (mouseleave)="hoveredCategoryIndex = null"
            >
                <div class="category-name">
                    <span
                        class="dot"
                        [style]="{
                            backgroundColor:
                                isCategoryActive(category) ||
                                hoveredCategoryIndex === idx
                                    ? 'white'
                                    : getColor(
                                          categoryIndexForRenaming === idx
                                              ? currentRenamingCategoryName
                                              : category.name
                                      )
                        }"
                    >
                    </span>
                    <input
                        #categoryRenameInput
                        *ngIf="categoryIndexForRenaming === idx"
                        [(ngModel)]="currentRenamingCategoryName"
                        class="category-rename-input"
                        (keydown)="onInputChange($event)"
                        (click)="$event.stopPropagation()"
                    />
                    <span
                        *ngIf="categoryIndexForRenaming !== idx"
                        class="category-name"
                        >{{ category.name }}</span
                    >
                </div>
                <div class="info-labels">
                    <div class="count-labels">
                        <span *ngIf="selectedOption === 'labels'">
                            {{ category.annotationCount }}
                        </span>
                        <span *ngIf="selectedOption === 'images'">
                            {{ category.imageCount }}
                        </span>
                    </div>
                </div>
                <div class="category-menu-wrapper" *ngIf="canEdit">
                    <div
                        class="three-dots-menu-wrapper"
                        *ngIf="idx !== menuForIndex"
                        (click)="onCategoryMenuClick($event, idx)"
                    >
                        <img
                            [id]="'menu-button-for-' + category.name"
                            [src]="
                                isCategoryActive(category) ||
                                hoveredCategoryIndex === idx
                                    ? 'assets/svg/reusable-svg/icon-dots-white.svg'
                                    : 'assets/svg/reusable-svg/icon-dots.svg'
                            "
                            alt="category menu button"
                        />
                    </div>
                    <div
                        class="category-menu-items"
                        *ngIf="categoryMenuOpen && idx === menuForIndex"
                    >
                        <div class="icon-wrapper">
                            <img
                                id="close-category-button"
                                class="info-icon"
                                src="assets/svg/reusable-svg/close-hover.svg"
                                alt="close category menu"
                                (click)="onCloseCategoryMenu($event)"
                            />
                        </div>
                        <div class="icon-wrapper">
                            <img
                                id="rename-category-button"
                                class="info-icon"
                                [title]="
                                    'imgDb.labelManager.categoryMenuItems.rename'
                                        | translate
                                "
                                src="assets/svg/img-db/category-manager/icon-rename.svg"
                                alt="rename category button"
                                (click)="onRename($event, idx)"
                            />
                        </div>
                        <div class="icon-wrapper">
                            <img
                                id="delete-category-button"
                                class="info-icon"
                                [title]="
                                    'imgDb.labelManager.categoryMenuItems.delete'
                                        | translate
                                "
                                src="assets/svg/project-split-screen/tree/icon-trash.svg"
                                alt="delete category button"
                                (click)="
                                    onDeleteCategoryClick($event, category)
                                "
                            />
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
    <ul
        *ngIf="!showSpinner && mode === 'overview'"
        class="list-group no-label-list"
        [ngClass]="{ 'not-alone': categories?.length > 0 }"
    >
        <li
            class="list-group-item"
            (click)="onClickEmptyCategory()"
            [class.selected]="isEmptyCategorySelected && mode === 'overview'"
        >
            <div class="category-name">
                <span class="no-label">
                    {{ 'imgDb.labelManager.noLabel' | translate }}</span
                >
            </div>
            <div class="info-labels">
                <div class="count-labels">
                    <span *ngIf="selectedOption === 'labels'"> 0 </span>
                    <span *ngIf="selectedOption === 'images'">{{
                        numberOfUncategorizedImages
                    }}</span>
                </div>
            </div>
        </li>
    </ul>
    <div class="spinner-wrapper" *ngIf="showSpinner">
        <div class="tryb-design-spinner"></div>
    </div>
</div>
